import { Flex, Box, Spacer, Input, Text, Button } from '@chakra-ui/react'
import { FC } from 'react'

import useParametrizationRevision from '@hook/parametrization/use-revision'

const BarToggle: FC = () => {
  const { paramsDates, handleParamsDate, getData, typeGrid, handledTypeGrid } =
    useParametrizationRevision()

  return (
    <Flex
      pos="relative"
      borderBottom="solid 1px"
      borderColor="gray.200"
      px={6}
      paddingTop={1}
      paddingBottom={2}
      alignItems="center"
    >
      <Box>
        <Text fontSize={14} mb={1}>
          Data Inicio
        </Text>
        <Input
          borderRadius={5}
          type="date"
          placeholder="Here is a sample placeholder"
          borderColor="blackAlpha.400"
          size="sm"
          value={paramsDates.dateInit}
          onChange={value =>
            handleParamsDate({
              name: 'dateInit',
              value: value.target.value
            })
          }
        />
      </Box>

      <Box marginLeft={2}>
        <Text fontSize={14} mb={1}>
          Data Fim
        </Text>
        <Input
          borderRadius={5}
          type="date"
          placeholder="Here is a sample placeholder"
          size="sm"
          borderColor="blackAlpha.400"
          value={paramsDates.dateEnd}
          onChange={value =>
            handleParamsDate({
              name: 'dateEnd',
              value: value.target.value
            })
          }
        />
      </Box>

      <Box pt={6} marginLeft={2}>
        <Button
          fontSize={14}
          size="sm"
          colorScheme="teal"
          variant="outline"
          onClick={getData}
        >
          Pesquisar
        </Button>
      </Box>

      <Spacer />

      <Box pt={6}>
        <Button
          fontSize={14}
          size="sm"
          color="orange"
          iconColor="orange"
          borderColor="orange"
          colorScheme="orange"
          onClick={() => handledTypeGrid(1)}
          variant={typeGrid === 1 ? 'outline' : 'ghost'}
        >
          Pendentes
        </Button>
      </Box>
      <Box pt={6}>
        <Button
          fontSize={14}
          size="sm"
          color="green"
          marginLeft={2}
          iconColor="green"
          borderColor="green"
          colorScheme="green"
          onClick={() => handledTypeGrid(2)}
          variant={typeGrid === 2 ? 'outline' : 'ghost'}
        >
          Aprovados
        </Button>
      </Box>
      <Box pt={6}>
        <Button
          fontSize={14}
          size="sm"
          color="red"
          marginLeft={2}
          iconColor="red"
          borderColor="red"
          colorScheme="red"
          onClick={() => handledTypeGrid(3)}
          variant={typeGrid === 3 ? 'outline' : 'ghost'}
        >
          Recusados
        </Button>
      </Box>
    </Flex>
  )
}

export default BarToggle
